import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=534cf0d2&scoped=true&"
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "./PageView.vue?vue&type=style&index=0&id=534cf0d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534cf0d2",
  null
  
)

export default component.exports